module.exports = ".header-top-right .logout {\n  cursor: pointer !important; }\n"